import {
    SUPPORTING_DOCUMENTS,
    TCDWCL_EMPLOYMENT_DETAILS,
    TCDWCL_QUALIFICATION_DETAILS
} from 'common/application.const/Licence/MyApplication/TCDWCLApplication';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatTCDWCLApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let qualificationDetails = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.QualificationList && licenceDetails.QualificationList.length > 0) {
        qualificationDetails = licenceDetails?.QualificationList.map((value: any, i: number) => ({
            'certificate-type': value?.CertificateTypeDes ?? '-',
            'course-name': value?.CourseName ?? '-',
            'certificate-name': value?.CertificateName ?? '-',
            'date-passed': value?.DatePassed ?? '-'
        }));
    }

    licence = {
        id: 'telecommunication-cable-detection-worker-class-licence',
        formID: 'telecommunication-cable-detection-worker-class-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication-TELE' ? 'Application Details' : 'Licence Details',
        values: {
            [`${TCDWCL_QUALIFICATION_DETAILS}-list`]: qualificationDetails ?? [...qualificationDetails],

            [`${TCDWCL_EMPLOYMENT_DETAILS}-self-employed`]: licenceDetails?.EmploymentDetails?.IsSelfEmployed ?? '-',

            [`${SUPPORTING_DOCUMENTS}-qualification`]: licenceDetails?.SupportingDocumentsAPImport?.QualificationDocName ?? '-',
            [`${SUPPORTING_DOCUMENTS}-practical-experience`]:
                licenceDetails?.SupportingDocumentsAPImport?.PracticalExperienceDocName ?? '-',
            [`${SUPPORTING_DOCUMENTS}-certification`]: licenceDetails?.SupportingDocumentsAPImport?.CertificationDocName ?? '-',
            [`${SUPPORTING_DOCUMENTS}-work-permit`]: licenceDetails?.SupportingDocumentsAPImport?.WorkPermitDocName ?? '-',
            [`${SUPPORTING_DOCUMENTS}-particulars-of-employer`]:
                licenceDetails?.SupportingDocumentsAPImport?.ParticularsOfEmployerDocName ?? '-',
            [`${SUPPORTING_DOCUMENTS}-cpf-info`]: licenceDetails?.SupportingDocumentsAPImport?.CPFInfoDocName ?? '-'
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
            values: {
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.cancellationInformation?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: 'Application Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-telecommunication-cable-detection-worker-class-licence',
            formID: 'amend-telecommunication-cable-detection-worker-class-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication-TELE' ? 'Application Details' : 'Licence Details',
            values: {
                [`${TCDWCL_QUALIFICATION_DETAILS}-list`]: qualificationDetails ?? [...qualificationDetails],

                [`${TCDWCL_EMPLOYMENT_DETAILS}-self-employed`]: licenceDetails?.EmploymentDetails?.IsSelfEmployed ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-qualification`]: licenceDetails?.SupportingDocumentsAPImport?.QualificationDocName ?? '-',
                [`${AMEND_SUPPORTING_DOCUMENTS}-practical-experience`]:
                    licenceDetails?.SupportingDocumentsAPImport?.PracticalExperienceDocName ?? '-',
                [`${AMEND_SUPPORTING_DOCUMENTS}-certification`]: licenceDetails?.SupportingDocumentsAPImport?.CertificationDocName ?? '-',
                [`${AMEND_SUPPORTING_DOCUMENTS}-work-permit`]: licenceDetails?.SupportingDocumentsAPImport?.WorkPermitDocName ?? '-',
                [`${AMEND_SUPPORTING_DOCUMENTS}-particulars-of-employer`]:
                    licenceDetails?.SupportingDocumentsAPImport?.ParticularsOfEmployerDocName ?? '-',
                [`${AMEND_SUPPORTING_DOCUMENTS}-cpf-info`]: licenceDetails?.SupportingDocumentsAPImport?.CPFInfoDocName ?? '-'
            }
        };
    }

    return licence;
};

const tcdwclPayloadApplication = {
    formatTCDWCLApplication
};

export default tcdwclPayloadApplication;
